import { render, staticRenderFns } from "./AddNewIntegration.vue?vue&type=template&id=f2cf0bc6&scoped=true"
import script from "./AddNewIntegration.vue?vue&type=script&lang=js"
export * from "./AddNewIntegration.vue?vue&type=script&lang=js"
import style0 from "./AddNewIntegration.vue?vue&type=style&index=0&id=f2cf0bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cf0bc6",
  null
  
)

export default component.exports